var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgList(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1025 15.0049C15.6067 15.0562 16 15.4823 16 16C16 16.5177 15.6067 16.9438 15.1025 16.9951L15 17H9C8.44772 17 8 16.5523 8 16C8 15.4477 8.44772 15 9 15H15L15.1025 15.0049Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1025 11.0049C13.6067 11.0562 14 11.4823 14 12C14 12.5177 13.6067 12.9438 13.1025 12.9951L13 13H9C8.44772 13 8 12.5523 8 12C8 11.4477 8.44772 11 9 11H13L13.1025 11.0049Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1025 7.00488C13.6067 7.05621 14 7.48232 14 8C14 8.51768 13.6067 8.94379 13.1025 8.99512L13 9H9C8.44772 9 8 8.55228 8 8C8 7.44772 8.44772 7 9 7H13L13.1025 7.00488Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 3C18.1569 3 19.5 4.34315 19.5 6V18C19.5 19.6569 18.1569 21 16.5 21H7.5C5.84315 21 4.5 19.6569 4.5 18V6C4.5 4.34315 5.84315 3 7.5 3H16.5ZM7.5 5C6.94772 5 6.5 5.44772 6.5 6V18C6.5 18.5523 6.94772 19 7.5 19H16.5C17.0523 19 17.5 18.5523 17.5 18V6C17.5 5.44772 17.0523 5 16.5 5H7.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/list.e28dba35c4418d3713d82ce915833b78.svg";
export { ForwardRef as ReactComponent };